module.exports = __webpack_public_path__ + "static/media/tab_talant.9840a5f8.jpg";